import { render, staticRenderFns } from "./GroupUsers.vue?vue&type=template&id=3b8154e4&scoped=true"
import script from "./GroupUsers.vue?vue&type=script&lang=js"
export * from "./GroupUsers.vue?vue&type=script&lang=js"
import style0 from "./GroupUsers.vue?vue&type=style&index=0&id=3b8154e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8154e4",
  null
  
)

/* custom blocks */
import block0 from "./GroupUsers.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports